<template>
  <v-container>
    <div class="d-flex justify-center">
      <v-card
        class="w-50 pa-5 mt-15 flex-column align-center justify-center text-center"
        height="80vh"
      >
        <v-img
          src="/public-portal/images/IMG_8229.jpg"
          height="50%"
          cover
        ></v-img>
        <v-card-title
          ><v-icon>mdi-alert-circle</v-icon> Page Not Found</v-card-title
        >
        <h2 class="text-center">
          We seem to have run aground while navigating to the requested page!
        </h2>
        <v-card-text>
          <h3>
            The page you were looking for does not exist here. The link you
            followed may be broken, or the content has been moved or deleted.
          </h3>
          <p>
            An automatic report has been generated so we can correct this issue,
            however please feel free to create a bug report if you would like to
            be notified of any updates.
          </p>
        </v-card-text>
      </v-card>
      <v-card
        class="w-50 pa-5 ma-15 flex-column align-center justify-center text-center"
        height="80vh"
      >
        <iframe
          src="https://communityboating.statuspage.io/"
          width="100%"
          height="100%"
        ></iframe>
      </v-card>
    </div>
  </v-container>
</template>
<script lang="ts" setup>
import { useRoute } from "vue-router";
import * as Sentry from "@sentry/vue";
const route = useRoute();

onMounted(() => {
  Sentry.captureMessage("User accessed 404 page", {
    level: "warning",
    tags: {
      type: "404",
    },
    extra: {
      path: route.fullPath,
      name: route.name,
      params: route.params,
      query: route.query,
      referrer: document.referrer,
    },
  });
});
</script>
